// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/engine-types.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/engine-types/engine-ignition-classification.js';
import g1 from '../lessons/aeronautics/engine-types/engine-types.js';

mount([g0, g1]);
